package org.catharsis.spendtel.feature.presentation

fun HomeState.isHomeBusy(): Boolean {
    return isPickingStatements ||
        isUploadingStatements ||
        isCreatingReport ||
        isConfirmingPurchase ||
        isPurchasing
}

fun HomeState.showsHomeProgress(): Boolean {
    return isUploadingStatements ||
        isCreatingReport ||
        isConfirmingPurchase ||
        isPurchasing
}

fun HomeState.homeProgressLabel(): String? {
    return uploadProgressLabel ?: when {
        isConfirmingPurchase -> "Confirming your payment…"
        isPurchasing -> "Opening checkout…"
        else -> null
    }
}
